import { JsonNeedPost } from '../annotation/jackson';
import { WebMenuItem } from './../../../../../pagecode/chm/ccmhmanno/home/megamenu/webmenuitem';
import { GuestViewForm } from './guest.viewform';

export class FavoriteViewForm extends GuestViewForm {

    // 交易分類
    @JsonNeedPost()
    menuCategory: string;

    /** 交易代號 */
    @JsonNeedPost()
    taskIxd: string;

    /** 我的最愛 */
    @JsonNeedPost()
    favoriteTaskList: WebMenuItem[];

    /** 錯誤訊息 */
    errorMessage: string;

    /** menu 所屬的地區 */
    @JsonNeedPost()
    areaType: string;

}
